import { styled } from "@mui/material";

export const UploadContainerStyles = styled("div")<{ isEmpty?: boolean }>`
  box-sizing: border-box !important;
  display: flex;
  flex-direction: column;
  border: 1px solid #f57b20;
  border-radius: 10px;
  margin: 0 25px 0 25px;
  cursor: pointer;
  height: calc(100% - 170px);
`;
